import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const ACGridMenuItems = props => {
  const {
    label,
    style,
    onElemClick,
    element,
    imgSrc,
    disabled = false,
  } = props;

  const Element = element;

  return (
    <div
      className="toggleLabel"
      data-test="dropButtonComponent"
      style={{ ...style }}
    >
      {element === 'button' ? (
        <Element
          type="button"
          className="toggleHeading"
          onClick={onElemClick}
          disabled={disabled}
        >
          {label}
        </Element>
      ) : (
        <Fragment>
          <img className="ibox-folder" src={imgSrc} alt="folder" />
          <Element onClick={onElemClick}>{label}</Element>
        </Fragment>
      )}
    </div>
  );
};

ACGridMenuItems.propTypes = {
  imgSrc: PropTypes.string,
  element:PropTypes.string,
  onElemClick: PropTypes.func,
  style: PropTypes.shape({}),
  label: PropTypes.string,
  infoBoxRef: PropTypes.shape({
    current: PropTypes.shape({
      targetRef: PropTypes.shape({
        current: PropTypes.shape({
          click: PropTypes.func,
        })
      }),
    }),
  }),
  disabled: PropTypes.bool,
};

export default ACGridMenuItems;
